import React, {Component} from 'react';
import crossPicto from "./assets/cross-picto.png";


class PictoLayer extends Component {

  constructor(props) {
    super(props);
    this.state = {
      checked: true
    };
  }

  selectPictoLayer = () => {
    if(this.state.checked === true){
      this.setState({checked: false});
      this.props.parentCallback(false, this.props.id);
    }
    else{
      this.setState({checked: true});
      this.props.parentCallback(true, this.props.id);
    }
  }

  render() {
    const isChecked = ! this.state.checked;
    return (
      <div>
        {isChecked
        ? <div>
            <input className='picto-input' type="image" src={this.props.picto} title={this.props.title} onClick={this.selectPictoLayer}/>
            <img src={crossPicto} className="cross-picto"/>
          </div>
        :<input className='picto-input-checked' type="image" src={this.props.picto} title={this.props.title} onClick={this.selectPictoLayer}/>}
      </div>
    );
  }
}

export default PictoLayer;